import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MaterialModuleModule} from '@/material-module/material-module.module';
import {CustomInputComponent} from '@/ui/forms/custom-input/custom-input.component';
import {FieldErrorsComponent} from "@/ui/field-errors/field-errors.component";

const customizedComponentDeclaration = [
  CustomInputComponent,
  FieldErrorsComponent,
];


@NgModule({
  declarations: customizedComponentDeclaration,
  imports: [
    CommonModule,
    MaterialModuleModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: customizedComponentDeclaration,
})
export class UiModule {}
